<template>
    <v-toolbar :color="toolbarColor" dark dense elevation="1">
        <v-icon left>mdi-file-document</v-icon>
        <v-toolbar-title>Release of Information Form</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'release-of-information-toolbar',
    computed: {
        toolbarColor() {
            return '#F64E60';
        }
    }
}
</script>